import { useQuery } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import { getIssuesForInspection } from '../services/IIMIssuesService';
import { iimReviewKeys } from './queryKeys';
const groupIssuesBySection = (issues) => {
    const groups = issues.reduce((acc, issue) => {
        const category = translate(issue.issueCategory, { namespace: 'features.iim_review.issue_categories' });
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(issue);
        return acc;
    }, {});
    return Object.entries(groups).map(([title, issuesParam]) => ({
        title,
        issues: issuesParam
    }));
};
export default function useIIMIssues(inspectionId, statuses, modeIA, options) {
    return useQuery({
        queryKey: iimReviewKeys.issues(inspectionId, statuses),
        queryFn: () => getIssuesForInspection(inspectionId, statuses),
        select: (response) => {
            const filteredIssues = (options === null || options === void 0 ? void 0 : options.markedForSuggestion)
                ? response.issues.filter((issue) => issue.markedForSuggestion)
                : response.issues;
            return {
                issues: filteredIssues,
                groupedIssues: groupIssuesBySection(filteredIssues),
                runStatus: response.runStatus
            };
        },
        staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
        cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
        retry: 3,
        enabled: (options === null || options === void 0 ? void 0 : options.enabled) !== false, // Default to true if not specified
        refetchInterval: false,
        refetchIntervalInBackground: false
    });
}
